import React from 'react';
import './WhyChooseUsSection.css';


import userFriendlyIcon from '../assets/icons/user_frendly.png';
import smartSolutionsIcon from '../assets/icons/smart_solu.png';
import seamlessIntegrationIcon from '../assets/icons/seamless.png';
import comprehensiveSuiteIcon from '../assets/icons/comprehensive.png';

const WhyChooseUsSection = () => {
  return (
    <section id="why-us" className="why-choose-us-section">
      <h2>Why Choose Us</h2>
      <p className="why-description">
        In a constantly evolving market, we ensure your needs are met with smart solutions that cater to your exact needs.
        We deliver 100% customer satisfaction through three core principles.
      </p>
      <div className="features-grid">
        <FeatureCard 
          icon={userFriendlyIcon} 
          title="User-Friendly Design" 
          description="Intuitive, easy-to-use interfaces for everyone."
        />
        <FeatureCard 
          icon={smartSolutionsIcon} 
          title="Smart Solutions" 
          description="Intelligent AI-driven apps for all daily tasks."
        />
        <FeatureCard 
          icon={seamlessIntegrationIcon} 
          title="Seamless Integration" 
          description="Works perfectly well with every major device and iOS."
        />
        <FeatureCard 
          icon={comprehensiveSuiteIcon} 
          title="Comprehensive Suite" 
          description="From business tools to social networking, we’ve got you covered."
        />
      </div>
    </section>
  );
};


const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="feature-card">
      <img src={icon} alt={title} className="feature-icon" />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default WhyChooseUsSection;
